import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
declare var $: any;
@Component({
  selector: 'app-member-acount-permisstion',
  templateUrl: './member-acount-permisstion.component.html',
  styleUrls: ['./member-acount-permisstion.component.scss']
})
export class MemberAcountPermisstionComponent implements OnInit {

  obj_tag_all: any = [];
  obj_tag: any = [];
  obj_tag_temp: any = [];
  obj_data_all: any;
  obj_data: any;

  constructor(
    private util: UtilService,
    private apiService: ApiService,
  ) { }

  ngOnInit() {
    let that = this;
    var table = $('#tData').DataTable();
    $('#tData tbody').on('click', 'tr', function () {
      that.obj_data = that.obj_data_all[table.row(this).index()];
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
      } else {
        table.$('tr.selected').removeClass('selected');
        $(this).addClass('selected');
      }

    });

    this.InitDropDownMemberType();
  }

  async InitDropDownMemberType() {
    var data = {}
    data["lang"] = this.util.GetLanguage();
    var res: any = await this.apiService.post('util', 'GetMemberType', data);
    if (res != null) {
      if (res.responseData != null) {
        this.util.InitDropdownAll(res.responseData, 'ddlMemberType');
        this.util.InitDropdown(res.responseData, 'ddlDlgMemberType');
      }
    }
  }

  BeforeSearch() {
    this.util.ShowWaiting(true);
    this.Search();
  }
  async Search() {
    try {
      this.obj_data = null;
      var data = {}
      data["group_id"] = $('#ddlMemberType').val();
      var resp: any = await this.apiService.post('member', 'GetPermiss', data);
      this.util.ShowWaiting(false);
      if (resp != null) {
        if (resp.isSuccess) {
          var obj: any = resp.responseData;
          this.obj_data_all = obj;
          var table = $('#tData').DataTable();
          table.clear().draw();
          for (var i = 0; i < obj.length; i++) {
            table.row.add(
              [obj[i].group_id,
              obj[i].group_desc,
              obj[i].update_date,
              obj[i].update_user]).draw();

          }


        }
      } else {
        this.util.ShowWaiting(false);
        this.util.ErrorDialog('System Error');
      }
    } catch (ex) {
      this.util.ShowWaiting(false);
      this.util.ErrorDialog(ex);
    }


  }
  async AddNew() {
    try {
      this.Clear();
      $('#txtDlgMenuId').val('');
      $('#txtDlgMenu').val('');
      $('#chkAdd').iCheck('uncheck');
      $('#chkEdit').iCheck('uncheck');
      $('#chkView').iCheck('uncheck');
      $('#chkDelete').iCheck('uncheck');
      $('#chkPrint').iCheck('uncheck');

      this.util.ShowWaiting(true);
      this.obj_data = null;
      // var data1 = {}
      // data1["document_code"] = 'tagframework';
      //var resp: any = await this.apiService.post('util', 'getdocno', data1);
      // if (resp != null) {
      // if (resp.isSuccess) {
      // var obj: any = resp.responseData;
      // $("#txtID").val(obj[0].doc_no);

      $("#divMain").hide();
      $("#divDetail").show();
      var data = {}
      var resp2: any = await this.apiService.post('master', 'getmenu', data);
      if (resp2 != null) {
        if (resp2.isSuccess) {
          var obj: any = resp2.responseData;
          if (obj != null) {
            this.obj_tag_all = [];
            this.obj_tag = [];
            for (var i = 0; i < obj.length; i++) {
              this.obj_tag_temp.push(obj[i]);
              this.obj_tag_all.push(obj[i]);
            }
            this.InitTagAll(this.obj_tag_all);
            this.InitTag(this.obj_tag);
          }
        } else {
          this.util.ErrorDialog(resp2.errorMessage);
        }
      } else {
        this.util.ShowWaiting(false);
        this.util.ErrorDialog('System Error');
      }


      this.util.ShowWaiting(false);
      // } else {
      //   this.util.ErrorDialog(resp.errorMessage);
      // }
      // } else {
      //   this.util.ShowWaiting(false);
      //   this.util.ErrorDialog('System Error');
      // }

    } catch (ex) {
      this.util.ShowWaiting(false);
      this.util.ErrorDialog(ex);
    }

  }
  InitTagAll(obj: any) {
    let that = this;
    $('#divDataAll').html('');
    var str = '';
    str += ' <table class="table table-bordered table-striped"  >';
    str += ' <thead>';
    str += ' <tr>';
    str += ' <th style="text-align: center;">ID</th>';
    str += ' <th style="text-align: center;">Description</th>';
    str += ' <th ></th>';
    str += ' </tr>';
    str += ' </thead>';
    str += ' <tbody>';
    for (var i = 0; i < obj.length; i++) {
      str += ' <tr>';
      str += ' <td align="center">' + obj[i].app_id + '</td>';
      str += ' <td >' + obj[i].app_desc + '</td>';
      str += ' <td  align="center">';
      str += ' <button type="button" class="btn btn-default" role="removerowall1" name="' + obj[i].app_id + '"><i class="fa fa-angle-right"></i></button>';
      str += ' </td>';
      str += ' </tr>';
    }
    str += ' </tbody>';
    str += ' </table>';
    $('#divDataAll').html(str);
    $("[role=removerowall1]").off('click');
    $("[role=removerowall1]").click(function () {
      that.RemoveRowAll($(this).attr('name'));
    });
  }
  InitTag(obj: any) {
    let that = this;
    $('#divDataSelect').html('');
    var str = '';
    str += ' <table class="table table-bordered table-striped"  >';
    str += ' <thead>';
    str += ' <tr>';
    str += ' <th style="text-align: center;">ID</th>';
    str += ' <th style="text-align: center;">Description</th>';
    str += ' <th ></th>';
    str += ' </tr>';
    str += ' </thead>';
    str += ' <tbody>';
    for (var i = 0; i < obj.length; i++) {
      str += ' <tr>';
      str += ' <td align="center">' + obj[i].app_id + '</td>';
      str += ' <td >' + obj[i].app_desc + '</td>';
      str += ' <td  align="center">';

      str += ' <button type="button" class="btn btn-default" role="permiss" title="แก้ไขสิทธิ์" name="' + obj[i].app_id + '"><i class="fa fa-edit"></i></button>';
      str += ' <button type="button" class="btn btn-default" role="removerow1" name="' + obj[i].app_id + '"><i class="fa fa-angle-left"></i></button>';

      str += ' </td>';
      str += ' </tr>';
    }
    str += ' </tbody>';
    str += ' </table>';
    $('#divDataSelect').html(str);
    $("[role=removerow1]").off('click');
    $("[role=removerow1]").click(function () {
      that.RemoveRow($(this).attr('name'));
    });

    $("[role=permiss]").off('click');
    $("[role=permiss]").click(function () {
      that.InitPermiss($(this).attr('name'));
    });
  }
  Cancel() {
    $("#divDetail").hide();
    $("#divMain").show();

  }
  Clear() {
    $('#ddlDlgMemberType').prop('disabled', false);


  }
  RemoveRowAll(x: any) {
    for (var i = 0; i < this.obj_tag_all.length; i++) {
      if (this.obj_tag_all[i].app_id == x) {
        this.obj_tag.push(this.obj_tag_all[i]);
        this.obj_tag_all.splice(i, 1);
        break;

      }
    }
    this.obj_tag = this.obj_tag.sort(function (a: any, b: any) {
      if (a.app_order > b.app_order) {
        return 1;
      }
      if (a.app_order < b.app_order) {
        return -1;
      }

      return 0;
    });

    this.InitTagAll(this.obj_tag_all);
    this.InitTag(this.obj_tag);
  }

  RemoveRow(x: any) {
    for (var i = 0; i < this.obj_tag.length; i++) {
      if (this.obj_tag[i].app_id == x) {
        this.obj_tag_all.push(this.obj_tag[i]);
        this.obj_tag.splice(i, 1);
        break;

      }
    }

    this.obj_tag_all = this.obj_tag_all.sort(function (a: any, b: any) {
      if (a.app_order > b.app_order) {
        return 1;
      }
      if (a.app_order < b.app_order) {
        return -1;
      }

      return 0;
    });
    this.InitTagAll(this.obj_tag_all);
    this.InitTag(this.obj_tag);
  }
  AddAllTag() {
    this.obj_tag_all = [];
    this.obj_tag = [];
    for (var i = 0; i < this.obj_tag_temp.length; i++) {
      this.obj_tag.push(this.obj_tag_temp[i]);
    }
    this.InitTagAll(this.obj_tag_all);
    this.InitTag(this.obj_tag);
  }
  RemoveAllTag() {
    this.obj_tag = [];
    this.obj_tag_all = [];
    for (var i = 0; i < this.obj_tag_temp.length; i++) {

      this.obj_tag_all.push(this.obj_tag_temp[i]);

    }
    this.InitTagAll(this.obj_tag_all);
    this.InitTag(this.obj_tag);
  }
  async Save() {
    try {

      if (this.util.ValidateForm()) {
        if (this.obj_tag != null) {
          if (this.obj_tag.length > 0) {
            var data = {}
            data["group_id"] = $('#ddlDlgMemberType').val();
            //data["framework_desc"] = desc_th;
            //data["framework_desc_en"] = desc_en;
            data["list_menu"] = this.obj_tag;
            var resp: any = await this.apiService.post('member', 'insertupdatepermiss', data);
            this.util.ShowWaiting(false);
            if (resp != null) {
              if (resp.isSuccess) {
                this.util.SuccessDialog('บันทึกสำเร็จ');
                this.obj_tag_all = [];
                this.obj_tag = [];
                this.obj_tag_temp = [];
                this.obj_data_all = null;
                this.obj_data = null;
                $("#divMain").show();
                $("#divDetail").hide();
                this.Search();
              } else {
                this.util.ErrorDialog(resp.errorMessage);
              }
            } else {
              this.util.ShowWaiting(false);
              this.util.ErrorDialog('System Error');
            }
          } else {
            this.util.ErrorDialog('กรุณาเลือกรายการ');
          }
        } else {

          this.util.ErrorDialog('กรุณาเลือกรายการ');
        }

      }
    } catch (ex) {
      this.util.ErrorDialog(ex);
    }
  }
  async EditData() {
    if (this.obj_data != null) {
      $('#txtDlgMenuId').val('');
      $('#txtDlgMenu').val('');
      $('#chkAdd').iCheck('uncheck');
      $('#chkEdit').iCheck('uncheck');
      $('#chkView').iCheck('uncheck');
      $('#chkDelete').iCheck('uncheck');
      $('#chkPrint').iCheck('uncheck');
      this.util.ShowWaiting(true);
      $("#ddlDlgMemberType").prop('disabled', true);
      $("#ddlDlgMemberType").val(this.obj_data.group_id);

      $("#divDetail").show();
      $("#divMain").hide();
      var data = {}
      data["group_id"] = '';
      var resp: any = await this.apiService.post('master', 'getmenu', data);

      if (resp != null) {
        if (resp.isSuccess) {
          var obj: any = resp.responseData;
          if (obj != null) {
            for (var i = 0; i < obj.length; i++) {
              this.obj_tag_temp.push(obj[i]);

            }

          }
        } else {
          this.util.ErrorDialog(resp.errorMessage);
        }
      } else {
        this.util.ShowWaiting(false);
        this.util.ErrorDialog('System Error');
      }


      var data1 = {}
      data1["group_id"] = this.obj_data.group_id;
      var resp: any = await this.apiService.post('master', 'GetMenuPermissNotIN', data1);

      if (resp != null) {
        if (resp.isSuccess) {
          var obj: any = resp.responseData;
          if (obj != null) {
            this.obj_tag_all = [];

            for (var i = 0; i < obj.length; i++) {
              this.obj_tag_all.push(obj[i]);

            }
            this.InitTagAll(this.obj_tag_all);
          }
        } else {
          this.util.ErrorDialog(resp.errorMessage);
        }
      } else {
        this.util.ShowWaiting(false);
        this.util.ErrorDialog('System Error');
      }



      var data2 = {}
      data2["group_id"] = this.obj_data.group_id;
      var resp: any = await this.apiService.post('master', 'GetMenuPermissIN', data2);
      if (resp != null) {
        if (resp.isSuccess) {
          var obj: any = resp.responseData;
          if (obj != null) {
            this.obj_tag = [];
            for (var i = 0; i < obj.length; i++) {
              this.obj_tag.push(obj[i]);
            }
            this.InitTag(this.obj_tag);
          }
        } else {
          this.util.ErrorDialog(resp.errorMessage);
        }
      } else {
        this.util.ShowWaiting(false);
        this.util.ErrorDialog('System Error');
      }



      this.util.ShowWaiting(false);
    }else{
      this.util.ErrorDialog('กรุณาเลือกรายการที่ต้องการแก้ไข');
    }
  }

  UpdatePermiss() {
    var app_id = $('#txtDlgMenuId').val();
    if (this.obj_tag != null) {
      if (this.obj_tag.length > 0) {
        for (var i = 0; i < this.obj_tag.length; i++) {
          if (app_id == this.obj_tag[i].app_id) {
            if ($('#chkAdd').prop("checked")) {
              this.obj_tag[i].add_status = "1";
            } else {
              this.obj_tag[i].add_status = "0";
            }
            if ($('#chkEdit').prop("checked")) {
              this.obj_tag[i].edit_status = "1";
            } else {
              this.obj_tag[i].edit_status = "0";
            }
            if ($('#chkView').prop("checked")) {
              this.obj_tag[i].view_status = "1";
            } else {
              this.obj_tag[i].view_status = "0";
            }
            if ($('#chkDelete').prop("checked")) {
              this.obj_tag[i].delete_status = "1";
            } else {
              this.obj_tag[i].delete_status = "0";
            }
            if ($('#chkPrint').prop("checked")) {
              this.obj_tag[i].print_status = "1";
            } else {
              this.obj_tag[i].print_status = "0";
            }
            console.log('yes');
            this.util.SuccessDialog('ปรับปรุงสำเร็จ');
            break;
          }
        }
      }
    }
  }

  InitPermiss(app_id: any) {
    if (this.obj_tag != null) {
      if (this.obj_tag.length > 0) {
        for (var i = 0; i < this.obj_tag.length; i++) {
          if (app_id == this.obj_tag[i].app_id) {
            $('#txtDlgMenuId').val(this.obj_tag[i].app_id);
            $('#txtDlgMenu').val(this.obj_tag[i].app_desc);
            if (this.obj_tag[i].add_status == "1") {
              $('#chkAdd').iCheck('check');
            } else {
              $('#chkAdd').iCheck('uncheck');
            }
            if (this.obj_tag[i].edit_status == "1") {
              $('#chkEdit').iCheck('check');
            } else {
              $('#chkEdit').iCheck('uncheck');
            }
            if (this.obj_tag[i].view_status == "1") {
              $('#chkView').iCheck('check');
            } else {
              $('#chkView').iCheck('uncheck');
            }
            if (this.obj_tag[i].delete_status == "1") {
              $('#chkDelete').iCheck('check');
            } else {
              $('#chkDelete').iCheck('uncheck');
            }
            if (this.obj_tag[i].print_status == "1") {
              $('#chkPrint').iCheck('check');
            } else {
              $('#chkPrint').iCheck('uncheck');
            }
            break;
          }
        }
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/member/member-acount-permisstion/member-acount-permisstion.component.ts